import { Pin } from "./util/Pin.js";
import { Fieldset } from "./util/Fieldset.js";
import { S } from "./Squaremap.js";

class Sidebar {
    /** @type {HTMLDivElement} */
    sidebar;
    /** @type {boolean} */
    showSidebar;
    /** @type {Pin} */
    pin;
    /** @type {Fieldset} */
    worlds;
    /** @type {Fieldset} */
    players;
    /** @type {HTMLButtonElement} */
    toggleButton;

    /**
     * @param {Settings_UI_Sidebar} json
     * @param {boolean} show
     */
    constructor(json, show) {
        this.sidebar = S.createElement("div", "sidebar", this);
        this.sidebar.setAttribute("role", "complementary");
        this.sidebar.setAttribute("aria-label", "Kaartmenu");
        const brand = document.createElement("a");
        brand.className = "map-brand";
        brand.href = "https://blokgenoten.nl";
        brand.target = "_blank";
        brand.rel = "noopener noreferrer";
        brand.innerHTML =
            '<img src="images/blokgenoten-logo.png" alt="" width="48" height="48"><span><strong>Blokgenoten</strong><small>Samen op de kaart.</small></span>';
        this.sidebar.appendChild(brand);
        this.toggleButton = document.createElement("button");
        this.toggleButton.id = "sidebar-toggle";
        this.toggleButton.type = "button";
        this.toggleButton.setAttribute("aria-controls", "sidebar");
        this.toggleButton.innerHTML =
            '<img src="images/blokgenoten-logo.png" alt="" width="24" height="24"><span>Kaartmenu</span>';
        this.toggleButton.onclick = (event) => {
            event.stopPropagation();
            const open = !this.sidebar.classList.contains("show");
            this.pin.pin(open);
            this.show(open);
        };
        document.body.appendChild(this.toggleButton);
        this.showSidebar = show;
        if (!show) {
            this.sidebar.style.display = "none";
            this.toggleButton.style.display = "none";
        }
        this.sidebar.addEventListener("click", (e) => {
            S.playerList.followPlayerMarker(null);
            e.stopPropagation();
        });
        document.body.appendChild(this.sidebar);

        this.pin = new Pin(json.pinned === "pinned");
        this.show(json.pinned !== "hide");
        if (json.pinned !== "hide") {
            this.sidebar.appendChild(this.pin.element);
        }

        this.worlds = new Fieldset("worlds", json.world_list_label);
        this.sidebar.appendChild(this.worlds.element);

        this.players = new Fieldset("players", json.player_list_label.replace(/{cur}/g, 0).replace(/{max}/g, 0));
        this.sidebar.appendChild(this.players.element);

        this.sidebar.onmouseleave = () => {
            if (!this.pin.pinned) {
                this.show(false);
            }
        };
        this.sidebar.onmouseenter = () => {
            if (!this.pin.pinned) {
                this.show(true);
            }
        };

        document.addEventListener("click", (e) => {
            if (!this.sidebar.contains(e.target) && !this.pin.pinned && this.sidebar.className === "show") {
                this.show(false);
            }
        });
    }
    show(show) {
        this.sidebar.className = show ? "show" : "";
        this.sidebar.inert = !show;
        this.toggleButton.setAttribute("aria-expanded", String(show));
        this.toggleButton.title = show ? "Kaartmenu sluiten" : "Kaartmenu openen";
    }
    remove() {
        this.sidebar.remove();
        this.toggleButton.remove();
    }
}

export { Sidebar };
